// extracted by mini-css-extract-plugin
export default {"container":"TermandConditions_container__RZVBG","button":"TermandConditions_button__jaGBc","title":"TermandConditions_title__EtF6k"};